var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('h3',[_vm._v("Inloggade")]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('queryview',{ref:"useractivity",attrs:{"qvtype":'UserActivity'}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }